// extracted by mini-css-extract-plugin
export default {"item":"item___BmnR2"};